<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12 col-lg-8  mt-8 d-flex flex-column flex-sm-row ">
            <h1 class="h3 ml-4 mr-6 heading" style="width: 30%;">
                ADD&nbsp;ON&nbsp;PACKS
            </h1>
            <div class="w-full">
                <mat-form-field class="flex-auto gt-xs:pr-3" style="width: 90%;">
                    <mat-select [placeholder]="'Active Plan Type'" [(ngModel)]="IDPlanType.planTypeActive" (selectionChange)="filterPlanType($event)">
                        <mat-option value="">All</mat-option>
                        <mat-option *ngFor="let plan of PlanStatusType" [value]="plan.value">{{plan.viewValue}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="w-full">
                <mat-form-field class="flex-auto gt-xs:pr-3" style="width: 90%;">
                    <mat-select [placeholder]="'AddOn Type'" [(ngModel)]="IDPlanType.planTypeId" (selectionChange)="filterPlanType($event)">
                        <mat-option value="">Select Add On Types</mat-option>
                        <mat-option *ngFor="let plan of addOnPlanTypes" [value]="plan.id">{{plan.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="w-full">
                <mat-form-field class="flex-auto gt-xs:pr-3" style="width: 90%;" [subscriptSizing]="'dynamic'">
                    <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:search'"></mat-icon>
                    <input matInput (keyup)="applyFilter($event)" [autocomplete]="'off'"
                        [placeholder]="'Search Add On'">
                </mat-form-field>
            </div>
           
        </div>
        <div class="col-sm-12 col-lg-4 mt-8 d-flex justify-content-end" *ngIf="isUserAllowedToCreateAddonPlanType">
            <button class="ml-4 addBtn" [ngClass]="{'btn-clr': true}" mat-flat-button [color]="'primary'"
                (click)="createAddOn()">
                <mat-icon class="white-icon" [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                <span class="ml-2 mr-1 txt" style="color: white">Create Add On</span>
            </button>
        </div>
    </div>
    <div class="mat-elevation-z8 mt-2 overflow-auto">
        <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)">

            <!-- ID Column -->
            <ng-container matColumnDef="AddOnName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Add On Name</th>
                <td mat-cell [ngClass]="{'delete-records-style': row.is_removed}" *matCellDef="let row"> {{row.name}}
                </td>
            </ng-container>
            <ng-container matColumnDef="AddOnHierarchy">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Add On Hierarchy</th>
                <td mat-cell [ngClass]="{'delete-records-style': row.is_removed}" *matCellDef="let row"> {{row.plan_hierarchy}}
                </td>
            </ng-container>
            <ng-container matColumnDef="AddOnType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Add On Plan Type</th>
                <td mat-cell [ngClass]="{'delete-records-style': row.is_removed}" *matCellDef="let row"> {{row.plan_type.name}} </td>

            </ng-container>
            <ng-container matColumnDef="AddOnPrice">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Add On Price/Month</th>
                <td mat-cell [ngClass]="{'delete-records-style': row.is_removed}" *matCellDef="let row">{{row.price_per_month}}
                </td>
            </ng-container>

            <ng-container matColumnDef="Actions">
                <th class="text-center" mat-header-cell *matHeaderCellDef>Actions</th>
                <mat-cell style="height: 52px;align-items: center;justify-content: center;" *matCellDef="let row;">
                    <button mat-button [matMenuTriggerFor]="menu">
                        <mat-icon style="color:#0038FF;font-size: 30px;" svgIcon="heroicons_outline:dots-vertical"></mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="getAddOnPlanById(row)">View</button>
                        <button mat-menu-item *ngIf="!row.is_removed && isUserAllowedToEditAddonPlanTypes"
                            (click)="editAddOn(row)">Edit</button>
                        <button mat-menu-item *ngIf="!row.is_removed && isUserAllowedToDeactivateAddonPlanType"
                            (click)="deactivatePlanType(row.id)">Deactivate</button>
                        <button mat-menu-item *ngIf="row.is_removed && isUserAllowedToReactivateAddonPlanType"
                            (click)="reactivatePlanType(row.id)">Reactivate</button>
                    </mat-menu>

                </mat-cell>

            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <!-- Row shown when there is no matching data. -->
            <div>
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="12">
                        <h3 style="display: flex;justify-content: center; margin:10%;">
                            No Records Found
                        </h3>
                    </td>
                </tr>
            </div>
        </table>
    </div>
    <mat-paginator style="display:flex;justify-content: end;" [pageSizeOptions]="[ 10, 25, 100]"
    aria-label="Select page of addon plans"></mat-paginator>
</div>